<div class="wrapper">
  @if (isSvgIcon) {
    <div class="svg-icon">
      <mat-icon svgIcon="{{ iconName }}"></mat-icon>
    </div>
  } @else {
    <div class="icon">
      <mat-icon inline>{{ iconName }}</mat-icon>
    </div>
  }
  <div class="row">
    <ng-content></ng-content>
  </div>
</div>
